import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { MySupportTeam } from '@/features/my-support-team'

export const Route = createFileRoute(
  '/_authenticated/_organization/my-support-team/',
)({
  beforeLoad: async () => requireRoles(['client', 'primary_contact']),
  component: MySupportTeam,
})
